// @ts-nocheck
import React from 'react';

import { cn } from '@cobliteam/ui/utils';
import { Popper as BasePopper, Paper } from '@material-ui/core';
import type { PopperProps } from '@material-ui/core/Popper';
import { type StyleRules, withStyles } from '@material-ui/core/styles';
import type { ClassNameMap } from '@material-ui/core/styles/withStyles';

import { colors } from '../styles/index';

const TooltipPaper = withStyles({
  root: {
    boxShadow: `2px 2px 10px 0 ${colors.custom.gray20}`,
    backgroundColor: colors.white,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: colors.gray.light,
    padding: 20,
  },
})(Paper);

// These weirds placement CSS rules are from this component demo in MUI site
// https://material-ui.com/utils/popper/#scroll-playground
const styles: StyleRules = {
  popper: {
    zIndex: 1300,
    '&[x-placement*="bottom"]': {
      marginTop: 10,
    },
    '&[x-placement*="bottom"] $arrow': {
      top: -6,
      width: '3em',
      height: '1em',
      '&::before': {
        transform: 'rotate(45deg) translateY(1px)',
        borderLeft: `1px solid ${colors.gray.light}`,
        borderTop: `1px solid ${colors.gray.light}`,
      },
    },
    '&[x-placement*="top"]': {
      marginBottom: 10,
    },
    '&[x-placement*="top"] $arrow': {
      bottom: -6,
      width: '3em',
      height: '1em',
      '&::before': {
        transform: 'translateY(-5px) rotate(45deg)',
        borderRight: `1px solid ${colors.gray.light}`,
        borderBottom: `1px solid ${colors.gray.light}`,
      },
    },
    '&[x-placement*="right"]': {
      marginLeft: 10,
    },
    '&[x-placement*="right"] $arrow': {
      left: -6,
      height: '3em',
      width: '1em',
      '&::before': {
        transform: 'translateY(3px) translateX(1px) rotate(45deg)',
        borderLeft: `1px solid ${colors.gray.light}`,
        borderBottom: `1px solid ${colors.gray.light}`,
      },
    },
    '&[x-placement*="left"]': {
      marginRight: 10,
    },
    '&[x-placement*="left"] $arrow': {
      right: -6,
      height: '3em',
      width: '1em',
      '&::before': {
        transform: 'translateX(-5px) translateY(3px) rotate(45deg)',
        borderRight: `1px solid ${colors.gray.light}`,
        borderTop: `1px solid ${colors.gray.light}`,
      },
    },
    '&[x-placement*="bottom-start"]': {
      marginLeft: -20,
    },
  },
  arrow: {
    position: 'absolute',
    fontSize: 7,
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 10,
      height: 10,
      borderWidth: 0,
      backgroundColor: 'white',
      borderStyle: 'solid',
    },
  },
};

interface IState {
  arrowRef: EventTarget | null;
}

interface IProps extends PopperProps {
  classes: ClassNameMap;
  arrow: boolean;
  paperClassName?: string;
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
class UnstyledPopper extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      arrowRef: null,
    };
  }

  private handleArrowRef = (node: HTMLElement) => this.setState({ arrowRef: node });

  public render() {
    const { arrow, classes, children, modifiers, handleMouseEnter, handleMouseLeave, className, paperClassName, ...otherProps } = this.props;
    const { arrowRef } = this.state;
    const myModifiers = {
      ...modifiers,
      arrow: {
        enabled: arrow,
        element: arrowRef,
      },
    };

    return (
      <BasePopper {...otherProps} className={cn(classes.popper, className)} modifiers={myModifiers}>
        {arrow && <span className={classes.arrow} ref={this.handleArrowRef} />}
        <TooltipPaper onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className={cn(paperClassName)}>
          {children}
        </TooltipPaper>
      </BasePopper>
    );
  }
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Popper = withStyles(styles)(UnstyledPopper);
